import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { memo, useState, useEffect } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import AccordionCohabitationDataForm from './form';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';

interface AccordionCohabitationDataProps {
  disabled?: boolean;
  isCohabitation?: boolean;
  withoutFamily?: boolean;
}

const AccordionCohabitationDataComponent = ({
  disabled = false,
  isCohabitation = false,
  withoutFamily = false,
}: AccordionCohabitationDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  useEffect(() => {
    onFieldsAccordionCohabitationDataChange({
      bondDate: formContext.values.generality?.birthDate,
      membershipDate: formContext.values.generality?.birthDate,
    });
  }, [formContext.values.generality?.birthDate]);

  const onFieldAccordionCohabitationDataChange = useEventCallback(
    (
      key: keyof AccordionFamilyCoexistence,
      value: AccordionFamilyCoexistence[keyof AccordionFamilyCoexistence]
    ) => {
      formContext.setFieldValue('familyCoexistence', {
        ...(formContext.values.familyCoexistence || {}),
        [key]: value,
      });
    }
  );

  const onFieldsAccordionCohabitationDataChange = useEventCallback(
    (values: AccordionFamilyCoexistence) => {
      formContext.setFieldValue('familyCoexistence', {
        ...(formContext.values.familyCoexistence || {}),
        ...values,
      });
    }
  );

  const resetForm = useEventCallback(() => {
    // reset solo dei campi editabili
    formContext.setFieldValue('familyCoexistence', {
      ...(formContext.values.familyCoexistence || {}),
      membershipDate: null,
      bondDate: null,
      relationship: null,
      progComponent: undefined,
    });
  });

  return withoutFamily ? (
    <></>
  ) : (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-family-coexistence-content"
        id="panel-person-family-coexistence-contentheader"
        expandIcon={<ExpandMore />}
      >
        <Typography>{!isCohabitation ? 'Famiglia' : 'Convivenza'}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionCohabitationDataForm
          disabled={disabled}
          values={formContext.values.familyCoexistence}
          onChange={onFieldAccordionCohabitationDataChange}
          resetForm={resetForm}
          isCohabitation={isCohabitation}
          errors={formContext.errors.familyCoexistence as FormikErrors<AccordionFamilyCoexistence>}
          touched={
            formContext.touched
              .familyCoexistence as unknown as FormikTouched<AccordionFamilyCoexistence>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionCohabitationDataComponent.displayName = 'Accordion Cohabitation data component';

const AccordionCohabitationData = memo(AccordionCohabitationDataComponent);

export default AccordionCohabitationData;
